import 'css/app.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from 'js/app';
import Platform from 'js/utils/platform';
import {configure} from 'mobx';
configure({
  enforceActions: true,
});

// platform setting
const {
  os,
  device,
  browser,
} = (new Platform());

const html = document.querySelector('html');
if (html) {
  html.setAttribute('data-os', os);
  html.setAttribute('data-device', device);
  html.setAttribute('data-browser', browser);
}


// React render
ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js